<template>
  <base-card-list
    :is-loading="isLoading"
    :scrollable-from="1023"
    :scrollable-to="420"
    :visible-rows="1"
    :items="isLoading ? productsSkeletons : productsData"
    :show-tag-link="isCustomCatalogModule ? moduleData.link : ''"
    class="game-main__offers">
    <template #title>
      {{ moduleData.name }}
    </template>

    <template #card="{ item }">
      <product-card
        :product="item"
        class="game-main__offer" />
    </template>

    <template #skeletonCard>
      <skeleton-product-card
        class="card game-main__offer" />
    </template>

    <template
      v-if="isCustomCatalogModule"
      #tagBlock>
      <div
        class="game-main__tag-link">
        <span class="game-main__tag-link-text">
          View more
        </span>

        <div class="game-main__tag-link-to">
          <span class="game-main__tag-link-headline">
            {{ moduleData.name }}
          </span>

          <button class="button game-main__arrowhead-button">
            <arrowhead-icon class="arrowhead-icon" />
          </button>
        </div>
      </div>
    </template>
  </base-card-list>
</template>

<script>
import BaseCardList from 'Components/ui/BaseCardList/BaseCardList.vue';
import ProductCard from 'Root/pages/game/components/ProductCard.vue';
import ArrowheadIcon from 'Components/ui/Icons/ArrowheadIcon.vue';
import CatalogModel from 'Models/CatalogModel';
import SkeletonProductCard from './SkeletonProductCard.vue';

export default {
  name: 'OffersModule',

  components: {
    SkeletonProductCard, BaseCardList, ProductCard, ArrowheadIcon,
  },

  props: {
    moduleData: {
      type: Object,
      required: true,
    },

    productsData: {
      type: Array,
      required: true,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      CatalogModel,
    };
  },

  computed: {
    isCustomCatalogModule() {
      return this.moduleData.type === CatalogModel.CATALOG_BLOCK_TYPES.CATALOG;
    },

    productsSkeletons() {
      return Array(this.moduleData.offers.length).fill({});
    },
  },
};
</script>

<style lang="scss" scoped>
.game-main__offers {
  /deep/.card-list__title {
    font-size: 25px;
    margin-bottom: 24px;
  }
}

.card {
  /deep/.card__title {
    font-size: 15px;
  }
}

.game-main__tag-link {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  align-self: end;
  flex-grow: 1;
}

.game-main__tag-link-to {
  display: grid;
  grid-template-columns: minmax(200px, 1fr) 1fr;
}

.game-main__tag-link-headline{
  color: $color--basic-white;
  font-size: 25px;
  font-style: normal;
  font-weight: 500;
}

.game-main__tag-link-text {
  color: rgba($color--basic-light-purple, .45);
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 8px;
}

.game-main__arrowhead-button {
  --size: 32px;

  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  background-color: rgba($color--basic-blue, 0.29);
  transition: background-color .3s ease-out;
  cursor: pointer;
  transform: rotate(-90deg);

  &:hover,
  &:focus {
    background-color: $color--basic-blue;
  }

  &:active {
    background-color: rgba($color--basic-blue, .31);
  }
}
</style>
